import { Injectable } from "@angular/core";
import { CampaignService } from "@app/core/services";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { NgxSpinnerService } from "ngx-spinner";
import { tap } from "rxjs/operators";
import { CampaignStateModel, GetCampaignData } from "./index";


@State<CampaignStateModel>({
    name: 'Campaign',
    defaults: {
        campaignList: {},
        activePage: 1,
        filterResult: {}
    }
})

@Injectable() 
export class CampaignState {

    constructor(private campaignService:    CampaignService) {}

    @Selector()
    static getCampaignListData(state: CampaignStateModel) {
        return state.campaignList;
    }

    @Selector()
    static getActivePage(state: CampaignStateModel) {
        return state.activePage;
    }

    @Selector()
    static getActiveFilterResult(state: CampaignStateModel) {
        return state.filterResult;
    }

    @Action(GetCampaignData) 
    getCampaignData({getState, setState}: StateContext<CampaignStateModel>, { pageIdex, filterResult }: GetCampaignData) {
        return this.campaignService.campaignList(pageIdex, filterResult).pipe(tap((res: any) => {
            const state = getState;
            setState({
                ...state,
                campaignList: res['data']['campaign'],
                activePage: pageIdex,
                filterResult: filterResult
            })
        }))

    }


}